<template>
  <div class="rule-wrapper">
    <div class="container">
      <h1></h1>
      <h1>กฎของเกม – เกมหมายเลข</h1>
      <button type="button" class="collapsible">1. เกมหมายเลข 75 ลูก</button>
      <div class="content" style="display: block">
        <div id="Rules" class="tabcontent1 rulesContent" style="display: block">
          <div class="rulesContent">
            <ul class="listSummary">
              <li>
                <p>
                  เกมหมายเลขเดิมพันได้ตลอด 24 ชั่วโมง
                  และคุณสามารถเข้าร่วมเกมได้โดยการวางเดิมพันที่หมายเลขใดใดจากลูกบอลหมายเลขที่จะถูกจับขึ้นมาจากเครื่องบิงโก
                  มีลูกบอลทั้งหมด 75 ลูก ตั้งแต่หมายเลข 1 ถึง 75.
                </p>
              </li>
              <li><p>จะมีการจับลูกบอลทั้งหมด 3 ลูกใน 1 เกม.</p></li>
              <li>
                <p>
                  ลูกบอลจะถูกใส่กลับไปยังเครื่องบิงโกหลังจากแต่ละเกมสิ้นสุดลงเพื่อเริ่มเกมใหม่.
                </p>
              </li>
              <li>
                <p>
                  จะมีลูกบอล 38 ลูกที่มีค่าตัวเลขเป็น "สูง" และ ลูกบอล 37
                  ลูกที่มีค่าตัวเลขเป็น "ต่ำ".
                </p>
              </li>
              <li>
                <p>
                  จะมีลูกบอล 38 ลูกที่มีค่าตัวเลขเป็น "เลขคี่" และ ลูกบอล 37
                  ลูกที่มีค่าตัวเลขเป็น "เลขคู่".
                </p>
              </li>
              <li>
                <p>จะมีลูกบอล 38 ลูกที่มี "สีแดง" และ ลูกบอล 37 ลูกที่มี "สีน้ำเงิน".</p>
              </li>
            </ul>
            <h3>เกมกำลังดำเนินการ (สด)</h3>
            <ul class="listDetail">
              <li>
                <h5>ลูกถัดไป สูง/ต่ำ</h5>
                <p>การทายผล "สูง / ต่ำ" ของลูกบอลลูกถัดไป.</p>
              </li>
              <li>
                <h5>ลูกถัดไป เลขคี่/เลขคู่</h5>
                <p>การทายผล "เลขคี่ / เลขคู่" ของลูกบอลลูกถัดไป.</p>
              </li>
              <li>
                <h5>ลูกถัดไป สีแดง/สีน้ำเงิน</h5>
                <p>การทายผล "สีแดง / สีน้ำเงิน" ของลูกบอลลูกถัดไป.</p>
              </li>
              <li>
                <h5>ลูกถัดไปแบบคอมโบ:</h5>
                <p><strong>สูง/เลขคี่ ต่ำ/เลขคี่ สูง/เลขคู่ ต่ำ/เลขคู่</strong></p>
                <p>
                  การทายผล "สูง/เลขคี่" "ต่ำ/เลขคี่" "สูง/เลขคู่" "ต่ำ/เลขคู่".
                </p>
                <p>
                  ตัวอย่าง: หากลูกบอลที่ถูกจับขึ้นมาคือหมายเลข 30 และผู้เล่นได้เดิมพันที่ "ต่ำ / เลขคู่" การเดิมพันถือว่าชนะ หากเดิมพันรูปแบบอื่นถือว่าเสีย.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button type="button" class="collapsible">2. เกมหมายเลข 35 ลูก</button>
      <div class="content" style="display: block">
        <div id="Rules" class="tabcontent1 rulesContent" style="display: block">
          <div class="rulesContent">
            <ul class="listSummary">
              <li>
                <p>
                  เกมหมายเลขเดิมพันได้ตลอด 24 ชั่วโมง และคุณสามารถเข้าร่วมเกมได้โดยการวางเดิมพันที่หมายเลขใดใดจากลูกบอลหมายเลขที่จะถูกจับขึ้นมาจากเครื่องบิงโก มีลูกบอลทั้งหมด 35 ลูก ตั้งแต่หมายเลข 1 ถึง 35.
                </p>
              </li>
              <li><p>จะมีการจับลูกบอลทั้งหมด 3 ลูกใน 1 เกม.</p></li>
              <li>
                <p>
                  ลูกบอลจะถูกใส่กลับไปยังเครื่องบิงโกหลังจากแต่ละเกมสิ้นสุดลงเพื่อเริ่มเกมใหม่.
                </p>
              </li>
              <li>
                <p>
                  จะมีลูกบอล 18 ลูกที่มีค่าตัวเลขเป็น "สูง" และ ลูกบอล 17 ลูกที่มีค่าตัวเลขเป็น "ต่ำ".
                </p>
              </li>
              <li>
                <p>
                  จะมีลูกบอล 18 ลูกที่มีค่าตัวเลขเป็น "เลขคี่" และ ลูกบอล 17 ลูกที่มีค่าตัวเลขเป็น "เลขคู่".
                </p>
              </li>
              <li>
                <p>
                  จะมีลูกบอล 18 ลูกที่มี "สีแดง" และ ลูกบอล 17 ลูกที่มี "สีน้ำเงิน".
                </p>
              </li>
            </ul>
            <h3>เกมกำลังดำเนินการ (สด)</h3>
            <ul class="listDetail">
              <li>
                <h5>ลูกถัดไป สูง/ต่ำ</h5>
                <p>การทายผลลูกบอลถัดไปเป็นสูงหรือต่ำ.</p>
              </li>
              <li>
                <h5>ลูกถัดไป เลขคี่/เลขคู่</h5>
                <p>การทายผลลูกบอลถัดไปเป็นเลขคี่หรือเลขคู่.</p>
              </li>
              <li>
                <h5>ลูกถัดไป สีแดง/สีน้ำเงิน</h5>
                <p>การทายผลลูกบอลถัดไปเป็นสีแดงหรือสีน้ำเงิน.</p>
              </li>
              <li>
                <h5>ลูกถัดไปแบบคอมโบ:</h5>
                <p><strong>สูง/เลขคี่ ต่ำ/เลขคี่ สูง/เลขคู่ ต่ำ/เลขคู่</strong></p>
                <p>
                  การทายผลรวมกันระหว่าง "สูง/เลขคี่" "ต่ำ/เลขคี่" "สูง/เลขคู่" "ต่ำ/เลขคู่".
                </p>
                <p>
                  ตัวอย่าง: หากลูกบอลที่ถูกจับขึ้นมาคือหมายเลข 16 และผู้เล่นได้เดิมพันที่ "ต่ำ/เลขคู่" การเดิมพันถือว่าชนะ หากเดิมพันรูปแบบอื่นถือว่าเสีย
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button type="button" class="collapsible">3. เงื่อนไขและข้อกำหนด</button>
      <div class="content" style="display: block">
        <div id="Rules" class="tabcontent1 rulesContent" style="display: block">
          <div class="rulesContent">
            <ol style="padding-left: 16px">
              <li>เกมหมายเลขใช้ได้เฉพาะสมาชิกที่ลงทะเบียนเท่านั้น.</li>
              <li>
                ผลลัพธ์ของทุกเกมหมายเลขจะถูกแสดงทันทีในรายงานประวัติผลการออกผลและถือเป็นข้อมูลทางการ
              </li>
              <li>
                ผู้ให้บริการเกมขอสงวนสิทธิ์ในการยกเลิกหรือทำให้การออกผลหรือการเดิมพันที่ได้รับผลกระทบเป็นโมฆะในกรณีที่มีปัญหาทางเทคนิคหรือความผิดปกติใด ๆ รวมถึงแต่ไม่จำกัดเฉพาะข้อผิดพลาดของซอฟต์แวร์ ความล้มเหลวของฮาร์ดแวร์ หรือปัญหาการเชื่อมต่อ.
              </li>
              <li>
                ผู้ให้บริการเกมขอสงวนสิทธิ์ในการยกเลิกหรือทำให้การออกผลหรือการเดิมพันที่ได้รับผลกระทบเป็นโมฆะหากมีข้อสงสัยว่าผู้เล่นกำลังมีส่วนร่วมในกิจกรรมที่ทุจริต การสมรู้ร่วมคิด หรือการกระทำที่ผิดกฎหมายอื่น ๆ.
              </li>
              <li>
                ผู้ให้บริการเกมขอสงวนสิทธิ์ในการยกเลิกหรือทำให้การออกผลหรือการเดิมพันที่ได้รับผลกระทบเป็นโมฆะในกรณีที่มีข้อผิดพลาด (เนื่องจากการป้อนข้อมูลที่ไม่ถูกต้องโดยผู้ดูแลระบบของผู้ให้บริการเกม) หรือความผิดปกติของระบบที่ส่งผลให้มีการใช้ราคาเดิมพันไม่ถูกต้องสำหรับเกมหมายเลข.
              </li>
              <li>
                การเดิมพันที่ได้รับการยอมรับและมีหมายเลขออกผลในหมายเหตุการยืนยันแล้วจะยังคงมีผลแม้ว่าสมาชิกจะออกจากระบบหรือถูกตัดการเชื่อมต่อจากเกมด้วยเหตุผลใด ๆ เช่น การเชื่อมต่อที่ไม่ดี การตัดการเชื่อมต่อ ฯลฯ
              </li>
              <li>
                หมายเลขตั๋วเดิมพันทำหน้าที่เป็นหมายเลขอ้างอิงสำหรับการเดิมพันทั้งหมดที่วางและได้รับการยืนยันสำเร็จ หมายเลขตั๋วเดิมพันแทนการเดิมพันที่ถูกต้อง ในกรณีที่ไม่มีหมายเลขตั๋วเดิมพันถูกสร้างขึ้นหลังจากการวางเดิมพัน หมายความว่าการเดิมพันนั้นไม่สำเร็จและไม่ถูกต้อง ดังนั้นควรหลีกเลี่ยงการวางเดิมพันซ้ำหรือทำธุรกรรมหลายรายการในวินาทีสุดท้ายของการออกผล".
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  head() {
    return {
      title: "rule",
    };
  },
};
</script>

<style>
body,
#app {
  background: #45464e url(/images/kenobg.jpg) no-repeat fixed;
  color: #fff;
  font-size: 1rem;
}
h1,
h2 {
  /* color: #161c2d; */
  font-size: 24px;
  font-weight: 500;
  margin: 20px 0 30px;
}

h3 {
  font-size: 20px;
  margin: 0;
  padding: 10px 0;
}

thead {
  color: black;
}
ol {
  text-align: left;
}

table {
  border: 1px solid #292a2e;
}

td {
  vertical-align: top;
  padding: 0.1in 5.75pt;
}

.rule-wrapper {
  text-align: left;
  /* padding: 80px 0; */
}
.rule-wrapper a {
  color: #1652f0;
  text-decoration: none;
}

.tablestyle {
  border-spacing: 0;
  border-collapse: separate !important;
  width: 100%;
  text-align: center;
}

.tablestyle thead th {
  background: #37405a;
  color: #b0bfd3;
  font-weight: normal;
  /*border-left: 1px solid #4A82F0;
    border-bottom: 1px solid #4A82F0;*/
}

.tablestyle th,
.tablestyle td {
  padding: 2px 10px;
  background: #fff;
  color: #4d4f5c;
}

.tablestyle .currency {
  text-align: right;
}

.tablestyle tbody tr td {
  vertical-align: top;
}

.tablestyle tbody tr:nth-of-type(2n + 0) td {
  background: #f2f6fe;
}

.input-group .form-control {
  border: 0;
}

.input-group-text {
  background: #fff;
  border: 0;
  line-height: normal;
}
.pull-right {
  float: right;
}

.resulticon {
  margin: 0 auto;
  display: block;
  font-size: 10px;
  background-color: #999;
  text-align: center;
  height: 18px;
  width: 18px;
  line-height: 18px;
  border-radius: 18px;
  cursor: pointer;
  color: #fff;
  font-weight: bold;
}

h5 {
  background: #292a2e;
  color: #fff;
  line-height: 50px;
  height: 50px;
  width: 100%;
}

.paragraphy-style {
  text-align: left;
  padding-left: 16px;
  padding-right: 16px;
}

.tablestyle td,
.tablestyle th {
  padding: 10px;
}

.tablecont {
  padding-left: 16px;
  padding-right: 16px;
}

.table-border {
  border-bottom: 1px solid #e3ecfe;
}

@media screen and (max-width: 480px) {
  .tablestyle td,
  .tablestyle th {
    padding: 5px;
    border-right: 1px solid #37405a;
  }
}

/* Style the tab */
.tab {
  overflow: hidden;
  width: inherit;
  /* filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr='#FDFCFC', endColorstr='#FBF9F9'); */
}

/* Style the buttons inside the tab */
.tab button {
  float: left;
  margin: 0;
  background-color: #f2f0f0;
  border: 1px solid #c0c0c0;
  color: #444;
  text-shadow: 0 1px #eee;
  outline: none;
  height: 100%;
  cursor: pointer;
  padding: 14px;
  width: 50%;
  transition: 0.3s;

  font-family: sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 16px;
  /* background-image: linear-gradient(top, #FDFCFC, #FBF9F9 50%, #F7F5F6 50%, #F2F0F0);  */
  background-image: -webkit-linear-gradient(
    top,
    #fdfcfc,
    #fbf9f9 50%,
    #f7f5f6 50%,
    #f2f0f0
  );
  /* display: inline-block; */
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: white;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: white !important;
  background-image: -webkit-linear-gradient(top, white, white 50%, white 50%, white);
  border-bottom: none;
}

/* Style the tab content */
.tabcontent1,
.tabcontent2,
.tabcontent3 {
  text-align: left;
  display: none;
  border: 1px solid #ccc;
  border-top: none;
  animation: fadeEffect 1s;
  padding: 20px;
}

.center {
  text-align: center;
}
.table-payout {
  text-align: center;
  width: 100%;
}
.container-center {
  text-align: -webkit-center;
}
.left {
  text-align: left;
}
.list-bet {
  text-align: center;
  padding: 0.1in 5.75pt;
}
.list-bet tr td:nth-child(2) {
  /* I don't think they are 0 based */
  text-align: left;
  padding: 0.1in 5.75pt;
}
.list-bet tr td:nth-child(4),
.list-bet tr td:nth-child(6) {
  /* I don't think they are 0 based */
  text-align: left;
  padding: 0.1in 5.75pt;
}

/* Go from zero to full opacity */
@keyframes fadeEffect {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
button {
  border-radius: 0;
}
.collapsible {
  color: black !important;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border-bottom: none;
  border: 1px solid #c0c0c0;
  text-align: left;
  outline: none;
  font-family: sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 18px;
  background-image: -webkit-linear-gradient(
    top,
    #fdfcfc,
    #fbf9f9 50%,
    #f7f5f6 50%,
    #f2f0f0
  );
  position: relative;
}

.active,
.collapsible:hover {
  background-image: -webkit-linear-gradient(top, white, white 50%, white 50%, white);
}

td {
  border: 1pt solid;
}
.content {
  display: none;
  overflow: hidden;
  background-color: #45464e;
}

@media (max-width: 540px) {
  button {
    font-size: 13px !important;
  }
}

.top-navbar {
  text-align: center;
  background: #292a2e;
  line-height: 50px;
  height: 50px;
  width: 100%;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.back-arrow {
  color: #fff;
  font-size: 24px;
  float: left;
  height: 24px;
  line-height: 24px;
  position: absolute;
  left: 4px;
  top: 14px;
}

.back-arrow:hover {
  color: #fff;
  text-decoration: none;
}

.gli {
  text-align: center;
}

.gli a {
  text-decoration: underline;
}
</style>

<style lang="scss" scoped>
.listSummary {
  margin-bottom: 20px;
}

.rulesContent ul,
.rulesContent ol {
  padding-left: 35px;
}

.rulesContent p {
  margin-bottom: 10px;
}

.rulesContent .listDetail {
  padding-left: 17px;
}

.rulesContent h5 {
  background: none;
}
</style>
